// extracted by mini-css-extract-plugin
export default {"body":"body-qX7wa","inputContainer":"inputContainer-ZmoId"};